import { IOperationsRepository } from "./OperationsRepository.types";

import {
    Operations,
    DataEntity,
    StoreOperation,
    StoreOperationUpdate
} from "@/entity/warehouse/Operations/Operations.types";

import { PaginationRequestType } from "@/entity/common/pagination.types";

import { getResponse, getResponseQs } from "@/repository/Helpers/repositoryLib";
import { ResponseDataType } from "@/form/form.types";
import Api from "@/repository/api";

export class OperationsRepository implements IOperationsRepository {
    async fetchAll(data?: FormData): Promise<Operations> {
        const response = await getResponse(`/store/operation/get`, data);
        return response.data as Operations;
    }
    async fetchData(data: PaginationRequestType): Promise<DataEntity> {
        const response = await getResponseQs(`/store/operation/get`, data);
        return response.data as DataEntity;
    }
    async OperationAction(data: StoreOperation): Promise<ResponseDataType> {
        const res = await Api.post("/store/operation/create", data);
        return res.data;
    }
    async update(data: StoreOperationUpdate): Promise<ResponseDataType> {
        const res = await Api.post("/store/operation/update", data)
        return  res.data;
    }
}
